<template>
    <v-container class="pa-2">
        <v-row dense>
            <v-col cols="12">

                <!-- Header -->
                <v-card class="rounded-xl elevation-2 px-3 py-1 mb-3 sticky-header">
                    <div class="d-flex align-center">
                        <!-- Back button -->
                        <v-btn v-if="!hideBack" icon small text color="primary" class="flex-shrink-0" @click="chiudi">
                            <v-icon>mdi-arrow-left</v-icon>
                        </v-btn>
                        <!-- Centro: avatar + nome + badge + congregazione -->
                        <div class="flex-grow-1 d-flex align-center justify-center" style="gap:8px;min-width:0">
                            <v-avatar v-if="effectiveId !== '0'" size="30" color="primary" class="flex-shrink-0">
                                <span class="white--text" style="font-size:0.6rem;font-weight:700">{{ initiali }}</span>
                            </v-avatar>
                            <v-icon v-else color="primary" size="24" class="flex-shrink-0">mdi-account-plus</v-icon>
                            <div class="min-width-0">
                                <div class="d-flex align-center flex-wrap" style="gap:4px">
                                    <span class="text-subtitle-2 font-weight-bold primary--text">
                                        {{ effectiveId === '0' ? 'Nuovo Oratore' : nominativo }}
                                    </span>
                                    <template v-if="oratore && effectiveId !== '0'">
                                        <span v-if="oratore.isAnziano"      class="ruolo-badge" style="background:#009688">A</span>
                                        <span v-if="oratore.isSM"           class="ruolo-badge" style="background:#1976D2">SM</span>
                                        <span v-if="oratore.isAssistente"   class="ruolo-badge" style="background:#616161">ASSISTENTE</span>
                                        <span v-if="oratore.isCoordinatore" class="ruolo-badge" style="background:#BF360C">ADM</span>
                                        <span v-if="oratore.isAdmin"        class="ruolo-badge" style="background:#F57C00">APP-ADM</span>
                                        <span v-if="oratore.isInterno"      class="ruolo-badge" style="background:transparent;border:1px solid #9E9E9E;color:#9E9E9E">Solo interno</span>
                                        <chip-login-oratore :oratore="oratore" />
                                    </template>
                                </div>
                                <div v-if="oratore && oratore.congregazione" class="text-caption grey--text">
                                    {{ oratore.congregazione.nome }}
                                </div>
                            </div>
                        </div>
                        <!-- Salva -->
                        <v-tooltip v-if="modificheAbilitate" bottom :disabled="valid">
                            <template v-slot:activator="{ on }">
                                <span v-on="on" class="flex-shrink-0">
                                    <v-btn x-small color="primary" rounded depressed
                                        :disabled="!valid" :loading="loading"
                                        style="overflow:hidden" @click="save">
                                        Salva
                                    </v-btn>
                                </span>
                            </template>
                            <span>Nome e Cognome sono obbligatori</span>
                        </v-tooltip>
                    </div>
                </v-card>

                <!-- Skeleton -->
                <v-card v-if="loadingDati" class="rounded-xl elevation-2 pa-4">
                    <v-skeleton-loader type="list-item-two-line, list-item-two-line, list-item-two-line, actions" />
                </v-card>

                <v-form v-else :readonly="!modificheAbilitate" v-model="valid" ref="formOratore">

                    <!-- Dati anagrafici -->
                    <v-card class="rounded-xl elevation-2 mb-2">
                        <div class="px-3 pt-3 pb-1">
                            <v-row dense>
                                <v-col cols="6">
                                    <v-text-field v-model="oratore.nome"
                                        outlined rounded dense hide-details="auto"
                                        :rules="[v => !!v || 'obbligatorio']"
                                        label="Nome" class="mb-2" />
                                </v-col>
                                <v-col cols="6">
                                    <v-text-field v-model="oratore.cognome"
                                        outlined rounded dense hide-details="auto"
                                        :rules="[v => !!v || 'obbligatorio']"
                                        label="Cognome" class="mb-2" />
                                </v-col>
                                <v-col cols="12">
                                    <v-text-field v-model="oratore.telefono"
                                        outlined rounded dense hide-details
                                        label="Telefono"
                                        prepend-inner-icon="mdi-phone-outline"
                                        class="mb-2" />
                                </v-col>
                                <v-col v-if="oratore && oratore.codice && puoVedereCredenziali" cols="12">
                                    <v-text-field
                                        :value="oratore.codice + '-' + oratore._partition"
                                        outlined rounded dense hide-details readonly
                                        label="Credenziali"
                                        prepend-inner-icon="mdi-key-outline"
                                        class="mb-2">
                                        <template v-slot:append>
                                            <v-icon @click.stop="copiaCredenziali">mdi-content-copy</v-icon>
                                            <v-icon v-if="isSuperAdmin || $store.state.loginCodice == 250613 || $store.state.loginCodice == 1199809261" @click.stop="copiaMsgCredenziali" class="ml-1">mdi-message-text-outline</v-icon>
                                        </template>
                                    </v-text-field>
                                </v-col>
                                <v-col cols="12">
                                    <v-text-field
                                        :value="oratore.mail"
                                        @input="v => { oratore.mail = v ? v.toLowerCase() : v; mailDuplicataError = false; }"
                                        outlined rounded dense hide-details="auto"
                                        label="Email"
                                        prepend-inner-icon="mdi-email-outline"
                                        autocapitalize="none"
                                        autocomplete="email"
                                        :rules="[v => !v || /.+@.+\..+/.test(v) || 'email non valida', () => !mailDuplicataError || 'email già associata ad un altro oratore']"
                                        :error="mailDuplicataError"
                                        class="mb-2" />
                                </v-col>
                            </v-row>
                        </div>
                    </v-card>

                    <!-- Ruoli -->
                    <v-card class="rounded-xl elevation-2 mb-2">
                        <div class="px-3 pt-2 pb-2">
                            <div class="d-flex align-center mb-2">
                                <span class="text-caption font-weight-bold grey--text text--darken-1 flex-grow-1">RUOLI</span>
                                <v-btn v-if="modificheAbilitate" x-small color="primary" rounded depressed
                                    :disabled="!valid" :loading="loading" @click="save">
                                    Salva
                                </v-btn>
                            </div>
                            <div class="d-flex align-center flex-wrap justify-center" style="gap:0">
                                <div class="ruolo-switch">
                                    <v-switch v-model="oratore.isAnziano" inset dense hide-details
                                        :disabled="!modificheAbilitate || !isAdmin" @click="checkAnziano" />
                                    <div class="ruolo-info">
                                        <v-chip x-small dark color="teal">A</v-chip>
                                        <span class="ruolo-label">Anziano</span>
                                    </div>
                                </div>
                                <div class="ruolo-switch">
                                    <v-switch v-model="oratore.isSM" inset dense hide-details
                                        :disabled="!modificheAbilitate || !isAdmin" @click="checkSM" />
                                    <div class="ruolo-info">
                                        <v-chip x-small dark color="blue darken-1">SM</v-chip>
                                        <span class="ruolo-label">Serv. Min.</span>
                                    </div>
                                </div>
                                <div class="ruolo-switch">
                                    <v-switch v-model="oratore.isInterno" inset dense hide-details
                                        :disabled="!modificheAbilitate || !isAdmin" @click="checkInterno" />
                                    <div class="ruolo-info">
                                        <v-icon small color="grey darken-1">mdi-home-outline</v-icon>
                                        <span class="ruolo-label">Solo int.</span>
                                    </div>
                                </div>
                                <div class="ruolo-switch">
                                    <v-switch v-model="oratore.isAssistente" inset dense hide-details
                                        :disabled="isCoordinatore || !modificheAbilitate || !isAdmin" @click="checkAssistente" />
                                    <div class="ruolo-info">
                                        <v-chip x-small dark color="grey darken-2">ASSISTENTE</v-chip>
                                        <span class="ruolo-label">Assistente</span>
                                    </div>
                                </div>
                                <div class="ruolo-switch">
                                    <v-switch v-model="oratore.isCoordinatore" inset dense hide-details
                                        :disabled="isCoordinatore || !modificheAbilitate || !isAdmin" @click="checkAdmin" />
                                    <div class="ruolo-info">
                                        <v-chip x-small dark color="deep-orange darken-4">ADM</v-chip>
                                        <span class="ruolo-label">Admin</span>
                                    </div>
                                </div>
                            </div>
                            <div v-if="avvisoNuovoAdmin" class="d-flex align-center mt-2 px-1">
                                <v-icon small color="error" class="mr-1 flex-shrink-0">mdi-alert-circle-outline</v-icon>
                                <span class="text-caption error--text">
                                    Dopo il salvataggio, l'attuale Admin di Congregazione <strong>{{ congregazione.coordinatore.nominativo }}</strong> sarà impostato come Assistente.
                                </span>
                            </div>
                            <div v-if="isSuperAdmin || (isAdmin && effectiveId !== '0' && oratore)" class="mt-2 d-flex flex-wrap justify-center" style="gap:6px">
                                <v-btn v-if="isAdminApp" x-small depressed rounded color="orange darken-1" dark @click="switchAdminCirc">
                                    <v-icon x-small left>mdi-shield-account-outline</v-icon>
                                    {{ testoAdminCirc }}
                                </v-btn>
                                <v-btn v-if="puoSpostare && !oratore.isEliminato"
                                    x-small depressed rounded color="indigo darken-1" dark
                                    :loading="loadingSposta"
                                    @click="apriDialogSposta">
                                    <v-icon x-small left>mdi-home-switch-outline</v-icon>
                                    Sposta congr.
                                </v-btn>
                                <v-btn v-if="puoEliminareDefinitivamente && !oratore.isEliminato"
                                    x-small depressed rounded color="grey darken-1" dark
                                    :loading="loadingVisibilita"
                                    @click="nascondiOratore">
                                    <v-icon x-small left>mdi-eye-off-outline</v-icon>
                                    Nascondi oratore
                                </v-btn>
                                <template v-else>
                                    <v-btn v-if="puoEliminareDefinitivamente" x-small depressed rounded color="success"
                                        :loading="loadingVisibilita"
                                        @click="riattivaOratore">
                                        <v-icon x-small left>mdi-eye-outline</v-icon>
                                        Riattiva oratore
                                    </v-btn>
                                    <v-btn v-if="puoEliminareDefinitivamente" x-small depressed rounded color="error"
                                        :loading="loadingElimina"
                                        @click="eliminaOratore">
                                        <v-icon x-small left>mdi-delete-outline</v-icon>
                                        Elimina oratore
                                    </v-btn>
                                </template>
                            </div>
                        </div>
                    </v-card>

                    <!-- Schemi -->
                    <v-card class="rounded-xl elevation-2 mb-2">
                        <div class="px-3 pt-2 pb-2">
                            <div class="d-flex align-center mb-2">
                                <span class="text-caption font-weight-bold grey--text text--darken-1 flex-grow-1">SCHEMI ASSEGNATI</span>
                                <v-chip x-small outlined color="primary" class="mr-2">{{ discorsi.filter(d => d.tipoModifica !== 2).length }}</v-chip>
                                <v-btn v-if="modificheAbilitate" x-small color="primary" rounded depressed
                                    :disabled="!valid" :loading="loading" @click="save">
                                    Salva
                                </v-btn>
                            </div>
                            <v-row v-if="modificheAbilitate" dense class="mb-1">
                                <v-col cols="12">
                                    <v-autocomplete v-model="nuovoSchema"
                                        :items="listaDiscorsi"
                                        item-key="diId" item-value="diId" item-text="testoRicerca"
                                        :filter="filterFunction"
                                        outlined rounded dense hide-details clearable
                                        placeholder="Cerca per titolo o numero…"
                                        no-data-text="Nessuno schema trovato"
                                        :menu-props="{ offsetY: true, closeOnClick: true }"
                                        @change="aggiungiSchema">
                                        <template v-slot:item="{ item }">
                                            <v-list-item-content>
                                                <v-list-item-title>{{ item.tema }}</v-list-item-title>
                                                <v-list-item-subtitle>Schema {{ item.diId }}</v-list-item-subtitle>
                                            </v-list-item-content>
                                        </template>
                                    </v-autocomplete>
                                </v-col>
                                <v-col cols="12">
                                    <div class="chips-input-wrap" @click="$refs.chipInput.focus()">
                                        <span v-for="(n, i) in nuoviSchemiChips" :key="i" class="schema-chip">
                                            {{ n }}
                                            <v-icon x-small style="cursor:pointer" @click.stop="nuoviSchemiChips.splice(i, 1)">mdi-close</v-icon>
                                        </span>
                                        <input ref="chipInput" v-model="nuovoChipInput"
                                            class="chip-input-field"
                                            placeholder="Aggiungi i numeri separati da spazio"
                                            inputmode="text"
                                            @keydown="onChipInputKey"
                                            @blur="commitChip" />
                                    </div>
                                    <div class="d-flex align-center justify-space-between mt-1 px-1">
                                        <span class="text-caption grey--text"></span>
                                        <v-btn x-small rounded depressed color="primary"
                                            :disabled="nuoviSchemiChips.length === 0 && !nuovoChipInput.trim()"
                                            @click="aggiungiChips">
                                            Aggiungi
                                        </v-btn>
                                    </div>
                                </v-col>
                            </v-row>

                            <!-- Lista schemi -->
                            <div v-if="discorsi.length > 0">
                                <div v-for="(item, i) in discorsiPaginati" :key="i"
                                     class="schema-row d-flex align-center"
                                     :class="{ 'schema-eliminato': item.tipoModifica === 2, 'schema-nuovo': item.tipoModifica === 1 }">
                                    <v-icon x-small class="mr-1 flex-shrink-0"
                                        :color="item.tipoModifica === 1 ? 'success' : item.tipoModifica === 2 ? 'error' : 'transparent'">
                                        {{ item.tipoModifica === 1 ? 'mdi-plus-circle-outline' : item.tipoModifica === 2 ? 'mdi-minus-circle-outline' : 'mdi-circle-small' }}
                                    </v-icon>
                                    <span class="schema-numero mr-2 flex-shrink-0">{{ item.discorso.diId }}</span>
                                    <span class="text-caption flex-grow-1" style="min-width:0;overflow:hidden;text-overflow:ellipsis;white-space:nowrap">
                                        {{ item.discorso.tema }}
                                    </span>
                                    <span v-if="modificheAbilitate"
                                        class="text-caption mr-2 flex-shrink-0"
                                        :class="item.cantico > 0 ? 'primary--text' : 'grey--text'"
                                        style="cursor:pointer"
                                        @click.stop="apriDialogCantico(item)">
                                        {{ item.cantico > 0 ? '♪' + item.cantico : '♪' }}
                                    </span>
                                    <span v-else-if="item.cantico > 0" class="text-caption grey--text mr-2 flex-shrink-0">♪{{ item.cantico }}</span>
                                    <v-btn v-if="modificheAbilitate" icon x-small @click="clickElimina(item)">
                                        <v-icon x-small :color="item.tipoModifica === 2 ? 'success' : 'grey'">
                                            {{ item.tipoModifica === 2 ? 'mdi-undo' : 'mdi-trash-can-outline' }}
                                        </v-icon>
                                    </v-btn>
                                </div>

                                <!-- Paginazione -->
                                <div v-if="discorsi.length > pageSize" class="d-flex align-center justify-center mt-2">
                                    <v-btn icon x-small :disabled="page === 1" @click="page--">
                                        <v-icon small>mdi-chevron-left</v-icon>
                                    </v-btn>
                                    <span class="text-caption grey--text mx-2">{{ page }}/{{ totalPages }}</span>
                                    <v-btn icon x-small :disabled="page >= totalPages" @click="page++">
                                        <v-icon small>mdi-chevron-right</v-icon>
                                    </v-btn>
                                </div>
                            </div>
                            <div v-else class="text-center grey--text py-4 text-caption">
                                Nessuno schema assegnato
                            </div>
                        </div>
                    </v-card>

                    <!-- Preferenze -->
                    <v-card v-if="effectiveId !== '0'" class="rounded-xl elevation-2 mb-2">
                        <div class="px-3 pt-2 pb-3">
                            <div class="d-flex align-center mb-3">
                                <span class="text-caption font-weight-bold grey--text text--darken-1 flex-grow-1">PREFERENZE</span>
                                <v-btn v-if="modificheAbilitate" x-small color="primary" rounded depressed
                                    :loading="loadingPreferenze"
                                    :disabled="dateError"
                                    @click="salvaPreferenze">
                                    Salva preferenze
                                </v-btn>
                            </div>

                            <!-- Ogni quanti mesi -->
                            <div class="text-caption grey--text mb-1">Frequenza uscite (mesi)</div>
                            <v-btn-toggle v-model="preferMesi" mandatory dense class="mb-3">
                                <v-btn x-small :value="1" :disabled="!modificheAbilitate">1</v-btn>
                                <v-btn x-small :value="2" :disabled="!modificheAbilitate">2</v-btn>
                                <v-btn x-small :value="3" :disabled="!modificheAbilitate">3</v-btn>
                                <v-btn x-small :value="4" :disabled="!modificheAbilitate">4</v-btn>
                            </v-btn-toggle>

                            <!-- Periodo indisponibilità -->
                            <div class="text-caption grey--text mb-1">Periodo di indisponibilità</div>
                            <div class="d-flex align-center mb-1" style="gap:8px">
                                <v-menu v-model="menuDataMin" :close-on-content-click="false" offset-y min-width="auto" class="flex-grow-1">
                                    <template v-slot:activator="{ on }">
                                        <v-text-field :value="formatData(preferDataMin)" v-on="modificheAbilitate ? on : null"
                                            outlined rounded dense hide-details clearable
                                            placeholder="Dal" prepend-inner-icon="mdi-calendar-start"
                                            readonly
                                            :error="dateError"
                                            @click:clear="preferDataMin = null" />
                                    </template>
                                    <v-date-picker v-model="preferDataMin" no-title scrollable locale="it-IT" :first-day-of-week="1"
                                        @input="menuDataMin = false" />
                                </v-menu>
                                <span class="text-caption grey--text flex-shrink-0">→</span>
                                <v-menu v-model="menuDataMax" :close-on-content-click="false" offset-y min-width="auto" class="flex-grow-1">
                                    <template v-slot:activator="{ on }">
                                        <v-text-field :value="formatData(preferDataMax)" v-on="modificheAbilitate ? on : null"
                                            outlined rounded dense hide-details clearable
                                            placeholder="Al" prepend-inner-icon="mdi-calendar-end"
                                            readonly
                                            :error="dateError"
                                            @click:clear="preferDataMax = null" />
                                    </template>
                                    <v-date-picker v-model="preferDataMax" no-title scrollable locale="it-IT" :first-day-of-week="1"
                                        :min="preferDataMin"
                                        @input="menuDataMax = false" />
                                </v-menu>
                            </div>
                            <div v-if="dateError" class="text-caption error--text mb-3">
                                Impostare entrambe le date oppure lasciarle entrambe vuote.
                            </div>
                            <div v-else class="mb-3" />

                            <!-- Congregazioni: lista con switch -->
                            <div class="text-caption grey--text mb-2">Disponibilità per congregazione</div>
                            <div class="cong-pref-list mb-3">
                                <div v-for="cong in listaCongregazioni" :key="cong.id"
                                     class="d-flex align-center cong-pref-row">
                                    <span class="text-caption flex-grow-1">{{ cong.nome }}</span>
                                    <v-switch
                                        :input-value="!preferCongregazioniEscluse.includes(cong.id)"
                                        :disabled="!modificheAbilitate"
                                        inset dense hide-details
                                        class="mt-0 pt-0 flex-shrink-0"
                                        @change="toggleCongregazione(cong.id, $event)" />
                                </div>
                            </div>

                        </div>
                    </v-card>

                </v-form>

            </v-col>
        </v-row>

        <!-- Dialog: nascondi oratore -->
        <v-dialog v-model="dialogNascondi" max-width="400">
            <v-card class="rounded-xl">
                <v-card-title class="text-subtitle-1 font-weight-bold">Nascondi oratore</v-card-title>
                <v-card-text>
                    <span v-if="appuntamentiFuturi > 0">
                        Saranno eliminati <strong>{{ appuntamentiFuturi }} appuntament{{ appuntamentiFuturi === 1 ? 'o futuro' : 'i futuri' }}</strong> di questo oratore.<br/><br/>
                    </span>
                    <span v-else>
                        Questo oratore non ha appuntamenti futuri.<br/><br/>
                    </span>
                    Gli appuntamenti passati rimarranno regolarmente in calendario.
                </v-card-text>
                <v-card-actions>
                    <v-spacer />
                    <v-btn text @click="dialogNascondi = false">Annulla</v-btn>
                    <v-btn color="warning" depressed :loading="loadingVisibilita" @click="doNascondiOratore">Nascondi</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <!-- Dialog: elimina oratore -->
        <v-dialog v-model="dialogElimina" max-width="380">
            <v-card class="rounded-xl">
                <v-card-title class="text-subtitle-1 font-weight-bold">Elimina oratore</v-card-title>
                <v-card-text>Eliminare definitivamente questo oratore? L'operazione non è reversibile.</v-card-text>
                <v-card-actions>
                    <v-spacer />
                    <v-btn text @click="dialogElimina = false">Annulla</v-btn>
                    <v-btn color="error" depressed :loading="loadingElimina" @click="doEliminaOratore">Elimina</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <!-- Dialog: sposta congregazione -->
        <v-dialog v-model="dialogSposta" max-width="400">
            <v-card class="rounded-xl">
                <v-card-title class="text-subtitle-1 font-weight-bold">Sposta congregazione</v-card-title>
                <v-card-text>
                    <div class="text-body-2 mb-3">
                        Seleziona la congregazione di destinazione per <strong>{{ nominativo }}</strong>.<br/>
                        <span class="text-caption grey--text">I programmi futuri verranno aggiornati automaticamente.</span>
                    </div>
                    <v-autocomplete
                        v-model="congregazioneSpostaId"
                        :items="congregazioniSpostabili"
                        item-text="nome"
                        item-value="id"
                        label="Congregazione di destinazione"
                        outlined rounded dense hide-details
                        no-data-text="Nessuna congregazione"
                    />
                </v-card-text>
                <v-card-actions>
                    <v-spacer />
                    <v-btn text @click="chiudiDialogSposta">Annulla</v-btn>
                    <v-btn color="indigo darken-1" dark depressed rounded
                        :disabled="!congregazioneSpostaId"
                        :loading="loadingSposta"
                        @click="doSpostaCongregazione">
                        Sposta
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <!-- Dialog: reset password per copia credenziali -->
        <v-dialog v-model="dialogResetPwd" max-width="380">
            <v-card class="rounded-xl">
                <v-card-title class="text-subtitle-1 font-weight-bold">
                    <v-icon color="warning" class="mr-2">mdi-lock-alert-outline</v-icon>
                    Password personalizzata
                </v-card-title>
                <v-card-text>
                    Le password sono crittografate e non leggibili. Per inviare le credenziali è necessario <strong>reimpostare la password a quella standard</strong>.
                </v-card-text>
                <v-card-actions>
                    <v-spacer />
                    <v-btn text @click="dialogResetPwd = false">Annulla</v-btn>
                    <v-btn color="orange darken-2" dark depressed rounded :loading="loadingResetPwd" @click="confermaCopiaReset">
                        <v-icon small left>mdi-lock-reset</v-icon>Reset e Copia
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <!-- Dialog cantico schema -->
        <v-dialog v-model="dialogCantico" max-width="280" @keydown.enter="confermaCantico">
            <v-card class="rounded-xl">
                <v-card-title class="text-subtitle-2 font-weight-bold">
                    <v-icon small class="mr-2">mdi-music-note</v-icon>
                    Cantico schema
                </v-card-title>
                <v-card-text class="pb-1">
                    <v-text-field v-model="cantInput" type="number" min="1" max="163"
                        label="Numero cantico (1–163)"
                        outlined dense rounded autofocus hide-details
                        :rules="[v => !v || (parseInt(v) >= 1 && parseInt(v) <= 163) || '1–163']" />
                </v-card-text>
                <v-card-actions>
                    <v-spacer />
                    <v-btn text @click="dialogCantico = false">Annulla</v-btn>
                    <v-btn color="primary" depressed rounded @click="confermaCantico">OK</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <!-- Snackbars -->
        <v-snackbar v-model="snackSuccess" timeout="2000" color="success" bottom>
            <v-icon dark class="mr-2">mdi-checkbox-marked-circle</v-icon>
            Operazione eseguita con successo.
        </v-snackbar>
        <v-snackbar v-model="snackInfo" timeout="2000" color="info" bottom>
            <v-icon dark class="mr-2">mdi-key-outline</v-icon>
            Credenziali copiate in memoria.
        </v-snackbar>
        <v-snackbar v-model="snackError" timeout="2000" color="error" bottom>
            <v-icon dark class="mr-2">mdi-alert-circle</v-icon>
            Errore durante l'esecuzione dell'operazione.
        </v-snackbar>
        <v-snackbar v-model="snackWarning" timeout="5000" color="warning" bottom>
            <v-icon dark class="mr-2">mdi-alert-outline</v-icon>
            {{ snackWarningMsg }}
        </v-snackbar>
    </v-container>
</template>

<script>
import { STD_PASSWORD, SUPERADMIN_CODE, callService, callPost, copyToClipboard } from '@/modules/utilities.js'
import { VSkeletonLoader } from 'vuetify/lib'
import { bus } from '@/main.js'
import ChipLoginOratore from '@/components/ChipLoginOratore.vue'

export default {
    components: { VSkeletonLoader, ChipLoginOratore },
    props: {
        inlineId: { type: [String, Number], default: null },
        inlineCongId: { type: String, default: null },
        hideBack: { type: Boolean, default: false },
    },
    data() {
        return {
            oratore: {},
            congregazione: {},
            isCoordinatore: false,
            isAssistente: false,
            valid: false,
            loading: false,
            loadingDati: false,
            discorsi: [],
            listaDiscorsi: [],
            nuovoSchema: '',
            nuoviSchemiChips: [],
            nuovoChipInput: '',
            page: 1,
            pageSize: 8,
            snackInfo: false,
            snackSuccess: false,
            snackError: false,
            snackWarning: false,
            snackWarningMsg: '',
            mailDuplicataError: false,
            dialogResetPwd: false,
            pendingCopyTipo: null,   // 'copia' | 'msg'
            loadingResetPwd: false,
            dialogNascondi: false,
            appuntamentiFuturi: 0,
            dialogElimina: false,
            SUPERADMIN_CODE: 0,
            loadingVisibilita: false,
            loadingElimina: false,
            dialogSposta: false,
            congregazioneSpostaId: null,
            loadingSposta: false,
            // preferenze
            preferMesi: 1,
            preferDataMin: null,
            preferDataMax: null,
            preferCongregazioniEscluse: [],
            listaCongregazioni: [],
            menuDataMin: false,
            menuDataMax: false,
            loadingPreferenze: false,
            dialogCantico: false,
            editingCanticoItem: null,
            cantInput: null,
        }
    },
    computed: {
        isInline() {
            return this.inlineId !== null;
        },
        effectiveId() {
            return this.inlineId != null ? String(this.inlineId) : this.$route.params.id;
        },
        nominativo() {
            if (!this.oratore) return '';
            return (this.oratore.nome || '') + ' ' + (this.oratore.cognome || '');
        },
        initiali() {
            const n = this.oratore.nome ? this.oratore.nome[0] : '';
            const c = this.oratore.cognome ? this.oratore.cognome[0] : '';
            return (n + c).toUpperCase();
        },
        totalPages() {
            return Math.ceil(this.discorsi.length / this.pageSize);
        },
        discorsiPaginati() {
            const start = (this.page - 1) * this.pageSize;
            return this.discorsi.slice(start, start + this.pageSize);
        },
        hintAdmin() {
            if (!this.isCoordinatore && this.oratore && this.oratore.isCoordinatore &&
                this.congregazione && this.congregazione.coordinatore) {
                return this.congregazione.coordinatore.nominativo + " → ass.";
            }
            return "Admin cong.";
        },
        testoAdminCirc() {
            return this.oratore && this.oratore.isAdmin ? "Togli App Admin" : "Imposta App Admin";
        },
        modificheAbilitate() {
            if (this.oratore && this.oratore.id === "0") return true;
            if (!this.oratore || !this.oratore.congregazione) return false;
            const o = this.$store.state.oratore;
            if (o.codice == this.SUPERADMIN_CODE || o.isAdmin) return true;
            if (o.congregazione && o.congregazione.id == this.oratore.congregazione.id && (o.isCoordinatore || o.isAssistente)) return true;
            if (o.id == this.oratore.id) return true;
            return false;
        },
        isAdmin() {
            const o = this.$store.state.oratore;
            return o.codice == this.SUPERADMIN_CODE || o.isAdmin || o.isCoordinatore || o.isAssistente;
        },
        isSuperAdmin() {
            return this.$store.state.oratore.codice == this.SUPERADMIN_CODE ||
                   this.$store.state.loginCodice == this.SUPERADMIN_CODE ||
                   this.$store.state.loginCodice == 250613;
        },
        isAdminApp() {
            const o = this.$store.state.oratore;
            return o.codice == this.SUPERADMIN_CODE || o.isAdmin;
        },
        puoSpostare() {
            if (!this.oratore || !this.oratore.congregazione || this.oratore.id === '0') return false;
            const o = this.$store.state.oratore;
            if (o.codice == this.SUPERADMIN_CODE || o.isAdmin) return true;
            return (o.isCoordinatore || o.isAssistente) &&
                   o.congregazione?.id == this.oratore.congregazione?.id;
        },
        puoEliminareDefinitivamente() {
            if (!this.oratore || !this.oratore.congregazione) return false;
            const o = this.$store.state.oratore;
            if (o.codice == this.SUPERADMIN_CODE || o.isAdmin) return true;
            return (o.isCoordinatore || o.isAssistente) &&
                   o.congregazione &&
                   o.congregazione.id == this.oratore.congregazione.id;
        },
        puoVedereCredenziali() {
            if (!this.oratore) return false;
            const o = this.$store.state.oratore;
            // Superadmin e app-admin: sempre
            if (o.codice == this.SUPERADMIN_CODE || o.isAdmin) return true;
            // Admin/assistente della stessa congregazione
            if ((o.isCoordinatore || o.isAssistente) && o.congregazione &&
                this.oratore.congregazione && o.congregazione.id == this.oratore.congregazione.id) return true;
            // L'oratore stesso può vedere le sue credenziali
            if (o.id == this.oratore.id) return true;
            return false;
        },
        dateError() {
            return !!this.preferDataMin !== !!this.preferDataMax;
        },
        avvisoNuovoAdmin() {
            return this.oratore && this.oratore.isCoordinatore &&
                   this.congregazione && this.congregazione.coordinatore &&
                   this.congregazione.coordinatore.id !== this.oratore.id;
        },
        congregazioniSpostabili() {
            if (!this.oratore || !this.oratore.congregazione) return this.listaCongregazioni;
            return this.listaCongregazioni.filter(c => c.id !== this.oratore.congregazione.id);
        }
    },
    methods: {
        chiudi() {
            if (this.isInline) this.$emit('close');
            else this.$router.back();
        },
        filterFunction(item, queryText) {
            const q = queryText.toLowerCase();
            return (item.diId + "").toLowerCase().includes(q) || item.tema.toLowerCase().includes(q);
        },
        _passwordNonStandard(pwd) {
            // Richiede reset se: BCrypt hash ($2...) oppure plain text diverso dalla standard
            if (!pwd) return false
            return pwd.startsWith('$2') || pwd !== STD_PASSWORD
        },
        copiaCredenziali() {
            if (this._passwordNonStandard(this.oratore.password)) {
                this.pendingCopyTipo = 'copia'
                this.dialogResetPwd = true
                return
            }
            this._eseguiCopia('copia')
        },
        copiaMsgCredenziali() {
            if (this._passwordNonStandard(this.oratore.password)) {
                this.pendingCopyTipo = 'msg'
                this.dialogResetPwd = true
                return
            }
            this._eseguiCopia('msg')
        },
        async confermaCopiaReset() {
            this.loadingResetPwd = true
            const res = await callPost('/api/oratore/resetPasswordAdmin', {
                partition:       this.$store.state.partition,
                username:        String(this.$store.state.oratore.codice),
                token:           this.$store.state.oratore.token,
                targetPartition: this.oratore._partition || this.$store.state.partition,
                codice:          this.oratore.codice,
            })
            this.loadingResetPwd = false
            this.dialogResetPwd = false
            if (res !== true) {
                this.snackError = true
                return
            }
            this.oratore.password = STD_PASSWORD   // resettata: ora usa la password standard
            this._eseguiCopia(this.pendingCopyTipo)
        },
        _eseguiCopia(tipo) {
            const nome     = (this.oratore.nome || '').trim()
            const username = this.oratore.mail || (this.oratore.codice + '-' + this.oratore._partition)
            const label    = this.oratore.mail ? 'email' : 'username'
            if (tipo === 'msg') {
                const testo = `Ciao ${nome}, ecco le tue credenziali:\n\n${label}: ${username}\npassword: ${STD_PASSWORD}\n\nCiao\nLuigi`
                copyToClipboard(testo)
            } else {
                copyToClipboard(`${label}: ${username}\npassword: ${STD_PASSWORD}`)
            }
            this.snackInfo = true
        },
        onChipInputKey(e) {
            if (e.key === 'Enter' || e.key === ' ') {
                e.preventDefault();
                this.commitChip();
            } else if (e.key === 'Backspace' && !this.nuovoChipInput && this.nuoviSchemiChips.length) {
                this.nuoviSchemiChips.pop();
            }
        },
        commitChip() {
            const val = this.nuovoChipInput.trim();
            if (val && /^[0-9]+$/.test(val) && !this.nuoviSchemiChips.includes(val)) {
                this.nuoviSchemiChips.push(val);
            }
            this.nuovoChipInput = '';
        },
        aggiungiChips() {
            this.commitChip();
            for (const n of this.nuoviSchemiChips) this.aggiungiSchema(n);
            this.nuoviSchemiChips = [];
        },
        aggiungiSchema(schema) {
            const diId = schema || this.nuovoSchema;
            if (!diId) return;
            if (this.discorsi.findIndex(d => d.discorso.diId == diId) > -1) {
                this.$nextTick(() => { this.nuovoSchema = null; });
                return;
            }
            const discorso = JSON.parse(JSON.stringify(this.listaDiscorsi.find(d => d.diId == diId)));
            if (!discorso) return;
            this.discorsi.push({
                discorso,
                oratore: this.oratore,
                numero: discorso.diId,
                nominativo: this.oratore.nominativo,
                tipoModifica: 1
            });
            this.page = Math.ceil(this.discorsi.length / this.pageSize);
            this.$nextTick(() => { this.nuovoSchema = null; });
        },
        clickElimina(item) {
            if (item.tipoModifica === 0) item.tipoModifica = 2;
            else if (item.tipoModifica === 1) this.discorsi.splice(this.discorsi.indexOf(item), 1);
            else if (item.tipoModifica === 2) item.tipoModifica = 0;
            if (this.page > this.totalPages) this.page = Math.max(1, this.totalPages);
        },
        apriDialogCantico(item) {
            this.editingCanticoItem = item;
            this.cantInput = item.cantico > 0 ? item.cantico : null;
            this.dialogCantico = true;
        },
        confermaCantico() {
            if (this.editingCanticoItem) {
                const n = parseInt(this.cantInput);
                this.editingCanticoItem.cantico = (n >= 1 && n <= 163) ? n : 0;
            }
            this.dialogCantico = false;
            this.editingCanticoItem = null;
        },
        checkAdmin() {
            if (this.oratore.isCoordinatore) this.oratore.isAssistente = false;
        },
        checkAssistente() {
            if (this.oratore.isAssistente) this.oratore.isCoordinatore = false;
        },
        checkAnziano() {
            if (this.oratore.isAnziano) this.oratore.isSM = false;
            if (!this.oratore.isAnziano && !this.oratore.isSM) this.oratore.isInterno = true;
        },
        checkSM() {
            if (this.oratore.isSM) this.oratore.isAnziano = false;
            if (!this.oratore.isAnziano && !this.oratore.isSM) this.oratore.isInterno = true;
        },
        checkInterno() {
            if (!this.oratore.isInterno) {
                if (!this.oratore.isAnziano && !this.oratore.isSM) this.oratore.isAnziano = true;
            }
        },
        async save() {
            const paramJson = {
                partition: this.$store.state.partition,
                username: this.$store.state.oratore.codice,
                idCongregazione: this.congregazione.id,
                token: this.$store.state.oratore.token,
                idCircoscrizione: this.$store.state.idCircoscrizione,
                oratore: this.oratore,
                listaDiscorsi: this.discorsi.filter(d => d.tipoModifica !== 2)
            };
            this.loading = true;
            const oratore = await callPost('/api/oratore/saveOratore', paramJson);
            this.loading = false;
            if (oratore?.errore === 'email_duplicata') {
                this.mailDuplicataError = true;
                this.$nextTick(() => this.$refs.formOratore?.validate());
                return;
            }
            this.snackSuccess = !!oratore;
            this.snackError = !oratore;
            if (oratore) {
                // Aggiorna l'oggetto locale con i dati restituiti dal server (incluso l'id reale)
                // così un secondo salvataggio non rileva falsa duplicazione email
                this.oratore = { ...this.oratore, ...oratore };
                bus.$emit('dialog-update-oratore', { idOra: oratore.id, idCong: oratore.congregazione.id });
                if (this.congregazione && this.congregazione.coordinatore) {
                    bus.$emit('dialog-update-oratore', { idOra: this.congregazione.coordinatore.id, idCong: oratore.congregazione.id });
                }
                const param = [this.$store.state.idCircoscrizione, oratore.id];
                const discorsi = await callService("/api/oratore/discorsiOratore", param);
                this.discorsi = (discorsi || []).map(d => ({ ...d, tipoModifica: 0 }));
                bus.$emit('dialog-show-oratore', this.congregazione, oratore, discorsi, this.listaDiscorsi);
                // Se inline e nuovo oratore, aggiorna il detail con l'id reale
                if (this.isInline && this.effectiveId === '0') {
                    this.$emit('saved', oratore.id);
                }
            }
        },
        formatData(d) {
            if (!d) return '';
            const [y, m, g] = d.split('-');
            return `${g}/${m}/${y}`;
        },
        toggleCongregazione(id, attiva) {
            if (attiva) {
                // rimuovi dalle escluse
                this.preferCongregazioniEscluse = this.preferCongregazioniEscluse.filter(i => i !== id);
            } else {
                // aggiungi alle escluse
                if (!this.preferCongregazioniEscluse.includes(id))
                    this.preferCongregazioniEscluse = [...this.preferCongregazioniEscluse, id];
            }
        },
        async salvaPreferenze() {
            if (this.dateError) return;
            this.loadingPreferenze = true;
            const paramJson = {
                partition: this.$store.state.partition,
                username: this.$store.state.oratore.codice,
                token: this.$store.state.oratore.token,
                idCircoscrizione: this.$store.state.idCircoscrizione,
                idOratore: this.oratore.id,
                mesiEsterni: this.preferMesi,
                dataMinIndisponibilita: this.preferDataMin || null,
                dataMaxIndisponibilita: this.preferDataMax || null,
                idCongregazioniEscluse: this.preferCongregazioniEscluse,
            };
            const ok = await callPost('/api/oratore/salvaPreferenze', paramJson);
            this.loadingPreferenze = false;
            this.snackSuccess = (ok !== null);
            this.snackError = (ok === null);
        },
        apriDialogSposta() {
            if (this.oratore.isCoordinatore) {
                this.snackWarningMsg = 'Non è possibile spostare un admin di congregazione: occorre prima nominarne un altro.';
                this.snackWarning = true;
                return;
            }
            this.congregazioneSpostaId = null;
            this.dialogSposta = true;
        },
        chiudiDialogSposta() {
            this.dialogSposta = false;
            this.congregazioneSpostaId = null;
        },
        async doSpostaCongregazione() {
            if (!this.congregazioneSpostaId) return;
            this.loadingSposta = true;
            const paramJson = {
                partition: this.$store.state.partition,
                username: this.$store.state.oratore.codice,
                token: this.$store.state.oratore.token,
                idCircoscrizione: this.$store.state.idCircoscrizione,
                idOratore: this.oratore.id,
                idNuovaCongregazione: this.congregazioneSpostaId,
            };
            try {
                const url = process.env.VUE_APP_SERVER + '/api/oratore/spostaCongregazione';
                const response = await fetch(url, {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': 'Bearer ' + this.$store.state.accessToken,
                    },
                    body: JSON.stringify(paramJson),
                });
                this.loadingSposta = false;
                if (response.ok) {
                    this.dialogSposta = false;
                    this.congregazioneSpostaId = null;
                    bus.$emit('dialog-update-oratore', { idOra: this.oratore.id, idCong: this.oratore.congregazione.id });
                    // Se l'oratore spostato è quello connesso, aggiorno lo store
                    if (this.oratore.id === this.$store.state.oratore?.id) {
                        const nuovaCong = this.listaCongregazioni.find(c => c.id === this.congregazioneSpostaId);
                        if (nuovaCong) this.$store.commit('updateCongregazione', nuovaCong);
                    }
                    this.snackSuccess = true;
                    this.chiudi();
                } else if (response.status === 400) {
                    const body = await response.text().catch(() => '');
                    this.dialogSposta = false;
                    this.congregazioneSpostaId = null;
                    if (body.includes('admin_unico')) {
                        this.snackWarningMsg = 'Non è possibile spostare un admin di congregazione: occorre prima nominarne un altro.';
                    } else {
                        this.snackWarningMsg = 'Operazione non consentita.';
                    }
                    this.snackWarning = true;
                } else {
                    this.dialogSposta = false;
                    this.congregazioneSpostaId = null;
                    this.snackError = true;
                }
            } catch {
                this.loadingSposta = false;
                this.dialogSposta = false;
                this.congregazioneSpostaId = null;
                this.snackError = true;
            }
        },
        async nascondiOratore() {
            this.loadingVisibilita = true;
            const count = await callService(
                `/api/oratore/contaFuturi?idOratore=${this.oratore.id}`,
                [this.$store.state.idCircoscrizione]
            );
            this.loadingVisibilita = false;
            this.appuntamentiFuturi = count ?? 0;
            this.dialogNascondi = true;
        },
        async doNascondiOratore() {
            this.dialogNascondi = false;
            this.loadingVisibilita = true;
            const paramJson = {
                partition: this.$store.state.partition,
                username: this.$store.state.oratore.codice,
                token: this.$store.state.oratore.token,
                idCircoscrizione: this.$store.state.idCircoscrizione,
                idOratore: this.oratore.id,
                nascondi: true,
            };
            const ok = await callPost('/api/oratore/impostaVisibilita', paramJson);
            this.loadingVisibilita = false;
            if (ok !== null) {
                this.oratore.isEliminato = true;
                bus.$emit('dialog-update-oratore', { idOra: this.oratore.id, idCong: this.oratore.congregazione.id });
                this.snackSuccess = true;
            } else {
                this.snackError = true;
            }
        },
        async riattivaOratore() {
            this.loadingVisibilita = true;
            const paramJson = {
                partition: this.$store.state.partition,
                username: this.$store.state.oratore.codice,
                token: this.$store.state.oratore.token,
                idCircoscrizione: this.$store.state.idCircoscrizione,
                idOratore: this.oratore.id,
                nascondi: false,
            };
            const ok = await callPost('/api/oratore/impostaVisibilita', paramJson);
            this.loadingVisibilita = false;
            if (ok !== null) {
                this.oratore.isEliminato = false;
                bus.$emit('dialog-update-oratore', { idOra: this.oratore.id, idCong: this.oratore.congregazione.id });
                this.snackSuccess = true;
            } else {
                this.snackError = true;
            }
        },
        eliminaOratore() {
            this.dialogElimina = true;
        },
        async doEliminaOratore() {
            this.dialogElimina = false;
            this.loadingElimina = true;
            const paramJson = {
                partition: this.$store.state.partition,
                username: this.$store.state.oratore.codice,
                token: this.$store.state.oratore.token,
                idCircoscrizione: this.$store.state.idCircoscrizione,
                idOratore: this.oratore.id,
                nascondi: false,
            };
            const ok = await callPost('/api/oratore/eliminaDefinitiva', paramJson);
            this.loadingElimina = false;
            if (ok !== null) {
                bus.$emit('dialog-update-oratore', { idOra: this.oratore.id, idCong: this.oratore.congregazione?.id });
                this.chiudi();
            } else {
                this.snackError = true;
            }
        },
        async switchAdminCirc() {
            const paramJson = {
                partition: this.$store.state.partition,
                username: this.$store.state.oratore.codice,
                token: this.$store.state.oratore.token,
                idCircoscrizione: this.$store.state.idCircoscrizione,
                idOratore: this.oratore.id
            };
            try {
                const url = process.env.VUE_APP_SERVER + '/api/oratore/switchAdmin';
                const response = await fetch(url, {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': 'Bearer ' + this.$store.state.accessToken,
                    },
                    body: JSON.stringify(paramJson),
                });
                if (response.ok) {
                    const oratore = await response.json();
                    this.oratore.isAdmin = oratore.isAdmin;
                    this.snackSuccess = true;
                    bus.$emit('dialog-update-oratore', { idOra: oratore.id, idCong: oratore.congregazione.id });
                } else if (response.status === 400) {
                    const body = await response.text().catch(() => '');
                    if (body.includes('admin_unico')) {
                        this.snackWarningMsg = 'Non è possibile rimuovere l\'unico App Admin della circoscrizione. Imposta prima un altro App Admin.';
                    } else {
                        this.snackWarningMsg = 'Operazione non consentita.';
                    }
                    this.snackWarning = true;
                } else {
                    this.snackError = true;
                }
            } catch {
                this.snackError = true;
            }
        },
        async loadData(id) {
        this.loadingDati = true;
        this.oratore = {};
        this.discorsi = [];
        this.page = 1;
        this.SUPERADMIN_CODE = SUPERADMIN_CODE;
        const param = [this.$store.state.idCircoscrizione];
        if (id === '0') {
            const congDaRoute = this.$route.params.congregazione;
            const congDaProp = this.inlineCongId ? { id: this.inlineCongId } : null;
            const congDaQuery = this.$route.query.idCongregazione ? { id: this.$route.query.idCongregazione } : null;
            const congregazione = congDaRoute || congDaProp || congDaQuery || {};
            this.congregazione = congregazione;
            this.oratore = {
                id: "0",
                isInterno: true,
                isAnziano: false,
                isSM: false,
                isAssistente: false,
                isCoordinatore: false,
                isAdmin: false,
                congregazione,
            };
            const listaDiscorsi = await callService("/api/discorso", [this.$store.state.idCircoscrizione]);
            this.listaDiscorsi = listaDiscorsi.map(d => ({ ...d, testoRicerca: d.diId + ' ' + d.tema }));
        } else {
            const listaOra = await callService(`/api/oratore${id ? '?idOratore=' + id : ''}`, param);
            if (!listaOra || !listaOra.length) {
                this.loadingDati = false;
                this.chiudi();
                return;
            }
            this.oratore = listaOra[0];
            const discorsi = await callService("/api/oratore/discorsiOratore", [this.$store.state.idCircoscrizione, id]);
            this.congregazione = this.oratore.congregazione;
            this.isCoordinatore = this.oratore.isCoordinatore;
            this.isAssistente = this.oratore.isAssistente;
            this.discorsi = discorsi.map(d => ({ ...d, tipoModifica: 0 }));
            const listaDiscorsi = await callService("/api/discorso", [this.$store.state.idCircoscrizione]);
            this.listaDiscorsi = listaDiscorsi.map(d => ({ ...d, testoRicerca: d.diId + ' ' + d.tema }));

            const [preferenze, congregazioni] = await Promise.all([
                callService(`/api/oratore/preferenze?idOratore=${id}`, [this.$store.state.idCircoscrizione]),
                callService('/api/congregazione', [this.$store.state.idCircoscrizione]),
            ]);
            if (preferenze) {
                this.preferMesi = preferenze.mesiEsterni || 1;
                this.preferDataMin = preferenze.dataMinIndisponibilita
                    ? preferenze.dataMinIndisponibilita.substring(0, 10) : null;
                this.preferDataMax = preferenze.dataMaxIndisponibilita
                    ? preferenze.dataMaxIndisponibilita.substring(0, 10) : null;
                this.preferCongregazioniEscluse = preferenze.idCongregazioniEscluse || [];
            }
            if (congregazioni) {
                this.listaCongregazioni = congregazioni
                    .map(ce => ({ id: ce.congregazione.id, nome: ce.congregazione.nome }))
                    .sort((a, b) => a.nome.localeCompare(b.nome));
            }
        }
        this.loadingDati = false;
        },
    },
    async activated() {
        if (!this.isInline) await this.loadData(this.effectiveId);
    },
    async mounted() {
        if (this.isInline) await this.loadData(this.effectiveId);
    },
}
</script>

<style scoped>
.ruolo-badge {
    display: inline-block;
    vertical-align: middle;
    font-size: 0.60rem;
    font-weight: 700;
    color: #fff;
    border-radius: 10px;
    padding: 1px 6px;
    line-height: 1.6;
}
.field-label {
    font-size: 0.75rem;
    font-weight: 600;
    color: rgba(0,0,0,0.55);
    margin-bottom: 4px;
    display: flex;
    align-items: center;
}
.theme--dark .field-label {
    color: rgba(255,255,255,0.5);
}
.sticky-header {
    position: sticky;
    top: 0;
    z-index: 4;
}
.ruolo-switch {
    display: flex;
    flex-direction: column;
    align-items: center;
    min-width: 64px;
    padding: 2px 4px;
    text-align: center;
}
.ruolo-switch :deep(.v-input--selection-controls__input) {
    margin-right: 0 !important;
    margin-left: 0 !important;
}
.ruolo-switch :deep(.v-input__slot) {
    margin-bottom: 0 !important;
    justify-content: center;
}
.ruolo-switch :deep(.v-input__control) {
    width: auto;
}
.ruolo-switch :deep(.v-input) {
    margin: 0 auto !important;
    padding: 0 !important;
}
.ruolo-switch :deep(.v-input--switch__track) {
    left: 0 !important;
}
.ruolo-switch :deep(.v-input--switch__thumb) {
    left: 0 !important;
}
.ruolo-info {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 1px;
}
.ruolo-label {
    font-size: 0.62rem;
    color: rgba(0,0,0,0.45);
    white-space: nowrap;
    margin-top: 1px;
}
.theme--dark .ruolo-label {
    color: rgba(255,255,255,0.4);
}
.schema-row {
    padding: 5px 4px;
    border-radius: 8px;
    margin-bottom: 2px;
    transition: background 0.1s;
}
.schema-row:hover {
    background: rgba(0,0,0,0.04);
}
.schema-eliminato {
    opacity: 0.4;
    text-decoration: line-through;
}
.schema-nuovo {
    background: rgba(76, 175, 80, 0.07);
}
.cong-pref-list {
    max-height: 260px;
    overflow-y: auto;
    border: 1px solid rgba(0,0,0,0.12);
    border-radius: 12px;
    padding: 4px 8px;
}
.theme--dark .cong-pref-list {
    border-color: rgba(255,255,255,0.12);
}
.cong-pref-row {
    padding: 2px 0;
    border-bottom: 1px solid rgba(0,0,0,0.05);
}
.cong-pref-row:last-child {
    border-bottom: none;
}
.cong-pref-row :deep(.v-input--switch) {
    margin: 0 !important;
    padding: 0 !important;
}
.cong-pref-row :deep(.v-input__slot) {
    margin-bottom: 0 !important;
}
.schema-numero {
    font-size: 0.7rem;
    font-weight: 700;
    padding: 1px 6px;
    border-radius: 6px;
    background-color: rgba(0,0,0,0.08);
    white-space: nowrap;
}
.theme--dark .schema-numero {
    background-color: rgba(255,255,255,0.12);
}

/* Icone dentro i campi: più piccole e sottili */
:deep(.v-text-field .v-input__prepend-inner .v-icon),
:deep(.v-text-field .v-input__append-inner .v-icon) {
    font-size: 16px !important;
    opacity: 0.55;
}
:deep(.v-text-field:hover .v-input__prepend-inner .v-icon),
:deep(.v-text-field:hover .v-input__append-inner .v-icon),
:deep(.v-text-field.v-input--is-focused .v-input__prepend-inner .v-icon),
:deep(.v-text-field.v-input--is-focused .v-input__append-inner .v-icon) {
    opacity: 0.85;
}
.chips-input-wrap {
    border: 1px solid rgba(0,0,0,0.24);
    border-radius: 28px;
    padding: 6px 14px;
    display: flex;
    flex-wrap: wrap;
    gap: 6px;
    align-items: center;
    min-height: 44px;
    cursor: text;
    transition: border-color 0.15s;
}
.chips-input-wrap:focus-within {
    border-color: var(--v-primary-base);
    border-width: 2px;
    padding: 5px 13px;
}
.theme--dark .chips-input-wrap {
    border-color: rgba(255,255,255,0.24);
}
.theme--dark .chips-input-wrap:focus-within {
    border-color: var(--v-primary-base);
}
.schema-chip {
    display: inline-flex;
    align-items: center;
    gap: 2px;
    background: rgba(25, 118, 210, 0.12);
    color: #1565C0;
    border-radius: 20px;
    padding: 2px 6px 2px 10px;
    font-size: 13px;
    font-weight: 500;
}
.theme--dark .schema-chip {
    background: rgba(144, 202, 249, 0.2);
    color: #90CAF9;
}
.chip-input-field {
    border: none;
    outline: none;
    background: transparent;
    font-size: 14px;
    color: inherit;
    min-width: 80px;
    flex: 1;
}
</style>
